import { TDispatch } from 'state';
import ErrorNotifier from '../../../../../services/error-notifier';
import setConversationPolicyApi from '../../api/set-conversation-policy';
import { SpotPolicy } from '../types';
import { SPOT_POLICY_MAPPER } from '../../utils';
import { setConversationPolicy as setConversationPolicySuccess } from './index';

type Payload = {
  conversationId: string;
  policy: SpotPolicy;
};

const setConversationPolicy = ({ conversationId, policy }: Payload) => {
  return async (dispatch: TDispatch) => {
    const policyValue: string = SPOT_POLICY_MAPPER[policy];

    try {
      await setConversationPolicyApi({ conversationId, policy: policyValue });
      dispatch(setConversationPolicySuccess({ conversationId, policy }));
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to set conversatio policy`, { conversationId, policy });
    }
  };
};

export default setConversationPolicy;
